import React, { useEffect, useState } from 'react'
import Button from '../Reusable/Button'
import { Hostingcards } from '../Reusable/Choose'
import Slider from './Slider'



const Hostinghome = () => {
   
    return (
        <div className='flex flex-col mt-6 z-[400] relative'>
            <div className='absolute lg:block hidden w-[400px] h-[400px] left-[-100px] top-[-200px] bg-blue-400 bg-opacity-30 rounded-full blur-2xl'></div>
            <div  className='flex lg:flex-row flex-col w-full justify-between z-[500] items-center'>
                <div data-aos={"fade-in"} className='lg:w-1/2 w-full text-white flex flex-col lg:items-start items-center gap-4'>
                    <p className='lg:text-[40px] text-[30px] lg:text-start text-center font-bold text-white'>Premier Mining Hosting Facilities at  <span className='text-[#2366CF]'>Blockfarms</span></p>
                    <p className='lg:text-xl lg:text-start text-center'>Unlock premium crypto mining solutions with Blockfarms, featuring state-of-the-art facilities at exceptionally low power rates. Start your mining journey today with power costs as low as $0.065 per kWh.</p>

                    <div className='flex flex-row items-center gap-10'>
                        <Button
                            link={"allProducts"}
                            title={"See Products"}
                        />
                        <div className='flex flex-row gap-3 items-center text-[white]'>
                            <div className='w-[40px] h-[40px] started rounded-4xl '>
                                <img src="" alt="" />
                            </div>
                            <p>How it works?</p>
                        </div>
                    </div>
                    <div data-aos={"zoom-in"}>
                        <p className='text-[20px] font-semibold text-white'>Trust by</p>
                        <div className='grid grid-cols-5'>
                            <img src="/Blockfarm/bitman.svg" alt="" />
                            <img src="/Blockfarm/iceriver.svg" alt="" />
                            <img src="/Blockfarm/jasminer.svg" alt="" />
                            <img src="/Blockfarm/canaan.svg" alt="" />
                            <img src="/Blockfarm/whatminner.svg" alt="" />
                        </div>
                    </div>
                </div>

                <div className='lg:w-[40%] hidden lg:block w-full '>
                    <Slider/>
                </div>
            </div>

            <div data-aos="fade-down" className='grid lg:grid-cols-5 md:grid-cols-2 gap-3 w-full justify-center lg:justify-between md:gap-[29%] lg:left-[-40px] lg:absolute lg:bottom-[-21rem] z-[600]'>
                <Hostingcards
                    img={"/Blockfarm/hosting/lowpower.svg"}
                    heading={"Low Power Cost"}
                    paragraph={"We offer miner hosting for as low as $0.065 per kWh"}
                />
                <Hostingcards
                    img={"/Blockfarm/hosting/cleanenergy.svg"}
                    heading={"Clean Energy"}
                    paragraph={"Our facilities operate on renewable energy sources, reducing the carbon footprint of your mining activities"}
                />
                <Hostingcards
                    img={"/Blockfarm/hosting/247.svg"}
                    heading={"24/7  Monitoring"}
                    paragraph={"On-site technicians providing round the clock support"}
                />
                <Hostingcards
                    img={"/Blockfarm/hosting/97.svg"}
                    heading={"97% Uptime"}
                    paragraph={"Industry leading uptime across all of facilities"}
                />
            </div>

        </div>
    )
}

export default Hostinghome